"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClazzExtends = void 0;
const Cores = __importStar(require("../../core"));
const evaluate_1 = require("../../evaluate");
const Exps = __importStar(require("../../exp"));
const infer_1 = require("../../infer");
const readback_1 = require("../../readback");
const stmt_1 = require("../../stmt");
const Values = __importStar(require("../../value"));
class ClazzExtends extends stmt_1.Stmt {
    constructor(name, parent, clazz, span) {
        super();
        this.name = name;
        this.parent = parent;
        this.clazz = clazz;
        this.span = span;
    }
    execute(mod) {
        return __awaiter(this, void 0, void 0, function* () {
            const inferredParent = (0, infer_1.infer)(mod, mod.ctx, this.parent);
            const parentClazz = (0, evaluate_1.evaluate)(mod.env, inferredParent.core);
            Values.assertClazzInCtx(mod, mod.ctx, parentClazz);
            const parentClazzCore = (0, readback_1.readbackClazz)(mod, mod.ctx, parentClazz);
            const ctx = Values.clazzExtendCtx(mod, mod.ctx, parentClazz);
            const superObjekt = Exps.ObjektUnfolded(Values.clazzPropertyNames(parentClazz).map((name) => Exps.PropertyPlain(name, Exps.Var(name))), this.span);
            const clazz = Exps.substitute(this.clazz, "super", superObjekt);
            const inferred = (0, infer_1.infer)(mod, ctx, clazz);
            Cores.assertClazz(inferred.core);
            const core = Cores.clazzAppend(parentClazzCore, inferred.core);
            core.name = this.name;
            const value = (0, evaluate_1.evaluate)(mod.env, core);
            mod.define(this.name, inferred.type, value);
        });
    }
    undo(mod) {
        mod.delete(this.name);
    }
}
exports.ClazzExtends = ClazzExtends;
//# sourceMappingURL=ClazzExtends.js.map